import React from 'react';
import { View, Image } from 'react-native';
import Typography from 'src/components/Text/Text';
import { styles } from './QuoteSummaryCard.styles';
import carrierLogo from 'src/assets/coverWhale.png';

type QuoteSummaryCardProps = {
  coverages: string[];
  premiumAmount: number;
};

const QuoteSummaryCard: React.FC<QuoteSummaryCardProps> = ({ coverages, premiumAmount }) => {
  return (
    <View style={styles.cardContainer}>
      <Image source={carrierLogo} style={styles.logo} />
      <Typography variant="h3" style={styles.premiumText}>
        $ {premiumAmount.toFixed(2)}
      </Typography>
      <Typography
        numberOfLines={1}
        ellipsizeMode="tail"
        variant="body1"
        style={styles.coveragesText}>
        {coverages.join(' | ')}
      </Typography>
    </View>
  );
};

export default QuoteSummaryCard;
